import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ProfileMenu from '../../components/Header/ProfileMenu';
import LangSelect from '../../components/LangSelect';
import Loader from '../../components/Loader';
import Logo from '../../components/Logo';
import PrimaryButton from '../../components/PrimaryButton';
import { t } from '../../constants/translations';
import { useLocale } from '../../contexts/locale.context';
import { useUser } from '../../contexts/user.context';
import CafeCard from './CafeCard';

const WelcomePage = () => {
  const { lang } = useLocale();
  const { cafeIds, fetchCafes, isLoading } = useUser();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/create');
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          p: 2,
        }}
      >
        <LangSelect />
        <ProfileMenu />
      </Box>
      <Box sx={{ mx: 'auto', my: 2, p: 2, textAlign: 'center', maxWidth: 400 }}>
        <Logo sx={{ mb: 2 }} />

        {isLoading && (
          <Box sx={{ mt: 4 }}>
            <Loader open />
          </Box>
        )}

        {!isLoading && (
          <>
            {!cafeIds?.length && (
              <Typography color="GrayText" sx={{ mt: 4 }}>
                {t.create_cafe_info[lang]}
              </Typography>
            )}

            {!!cafeIds?.length && (
              <Typography color="GrayText" sx={{ mt: 4 }}>
                {t.my_cafes[lang]}
              </Typography>
            )}

            {cafeIds?.map((id) => (
              <Box key={id} sx={{ my: 2 }}>
                <CafeCard id={id} />
              </Box>
            ))}

            <PrimaryButton sx={{ my: 2 }} onClick={handleClick} variant={cafeIds?.length ? 'text' : 'contained'}>
              {t.create_cafe[lang]}
            </PrimaryButton>
          </>
        )}
      </Box>
    </>
  );
};

export default WelcomePage;
